import { Navigate, Route, Routes } from 'react-router-dom';

import OfxPage from './Ofx';
import TorfxPage from './Torfx';
import ContainerWrapper from '@/pages/layout/ContainerWrapper';
import FxPage from './FxPage';

export const FXRoutes = () => {
  return (
    <ContainerWrapper>
      <Routes>
        <Route path="/" element={<FxPage />} />
        <Route path="ofx" element={<OfxPage />} />
        <Route path="torfx" element={<TorfxPage />} />
      </Routes>
    </ContainerWrapper>
  );
};
